/* eslint-disable @typescript-eslint/no-unsafe-argument */
import type { AnalysisCompType } from "@/generated/graphql"
import { useStore } from "@nanostores/react"
import { currentCriterionStore } from "@/stores/compSortingDataStore"
import { Image } from "expo-image"
import { View } from "react-native"
import { Tiny } from "@/components/standard/BFText"
import React from "react"
import type { AnalysisWithCompsType } from "@/queries/analysis"
import { compCompareText } from "@/utils/CompUtils"
import { type PrimarySortCriterion } from "@/types"

export interface CompAvatarImageProps {
  analysis: AnalysisWithCompsType | null
  comp: AnalysisCompType
  className?: string
}

export const CompAvatarImage = ({
  comp,
  analysis,
  className,
}: CompAvatarImageProps) => {
  const sortCriterion = useStore(currentCriterionStore)

  const bannerLabel = compCompareText(
    sortCriterion as PrimarySortCriterion,
    comp,
    analysis
  )

  return (
    <View
      className={`w-[70px] h-[66px] rounded-lg overflow-hidden relative ${className}`}
    >
      <Image
        style={{ width: 70, height: 66 }}
        source={{
          uri:
            comp.arvcomp?.heroImage || "https://fakeimg.pl/300x200?text=Comp",
        }}
      />
      <View
        className={`absolute h-5 bottom-0 inset-x-0 ${comp.isSelected ? "bg-calm-blue" : "bg-warm-grey"} rounded-b-lg justify-center items-center p-0.5`}
      >
        <Tiny className="text-white text-center leading-none mt-0.5 uppercase">
          {bannerLabel}
        </Tiny>
      </View>
    </View>
  )
}
